export function generateTimeId() {
  const d = new Date();
  let id = d.getTime();
  // id ex.  1730718175343
  console.log(id);
  return id.toString();
}
